import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sliver_ic_cdjf_normal",
  "use": "icon-sliver_ic_cdjf_normal-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sliver_ic_cdjf_normal\">\n<path d=\"M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1Z\" fill=\"url(#icon-sliver_ic_cdjf_normal_paint0_linear_1473_12058)\" />\n<path d=\"M15 17H10.99C8.79 17 7 15.21 7 13.011V10.99C7 8.79 8.79 7 10.99 7H15C15.553 7 16 7.448 16 8C16 8.552 15.553 9 15 9H10.99C9.893 9 9 9.893 9 10.99V13.011C9 14.107 9.893 15 10.99 15H15C15.553 15 16 15.447 16 16C16 16.553 15.553 17 15 17Z\" fill=\"white\" />\n<defs>\n<linearGradient id=\"icon-sliver_ic_cdjf_normal_paint0_linear_1473_12058\" x1=\"17.5\" y1=\"18\" x2=\"6\" y2=\"6.5\" gradientUnits=\"userSpaceOnUse\">\n<stop stop-color=\"#0FB833\" />\n<stop offset=\"1\" stop-color=\"#4BD214\" />\n</linearGradient>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sliver_ic_cdjf_normal.svg
// module id = kmY9
// module chunks = 87